import type React from 'react';

import { Text } from '@change/ds-core-ui';
import { SignaturesIcon } from '@change/ds-icons';

import { useNow } from '@change-corgi/core-react/date';
import { useI18n } from '@change-corgi/core-react/i18n';

type Props = Readonly<{
	description: string;
	createdAt: string;
}>;

export const Milestone = (({ ref, description, createdAt }) => {
	const now = useNow();
	const { localizeRelativeTime } = useI18n();

	return (
		<div ref={ref} className="border-stroke-weaker bg-background-raised flex gap-3 rounded-lg border px-5 py-3">
			<div className="bg-icon-accent-primary h-10 w-10 rounded-full p-2">
				<SignaturesIcon size={21} className="text-icon-inverse-strong" />
			</div>
			<div>
				<Text variant="body" fontWeight="bold" size="large">
					{description}!
				</Text>
				<div className="flex flex-row gap-0.5 whitespace-nowrap">
					<Text as="div" variant="body" size="small">
						{localizeRelativeTime(now, createdAt)}
					</Text>
				</div>
			</div>
		</div>
	);
}) as React.FC<
	Props & {
		ref?: React.RefObject<HTMLDivElement>;
	}
>;
